export default "__VITE_ASSET__B1UMz3Pg__"